export default "__VITE_ASSET__BKJKqYK9__"